import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {TokenStorage} from '../../core/token.storage';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
 
// const URL = '/api/';
//const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';
const URL = '/sonavie/uploadFile';

// const URL = '/api/';
//const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';
//const URL = '/sonavie/uploadFile';
//const URL = 'http://192.168.1.107:8000/sonavie/uploadFile';

const TOKEN_HEADER_KEY = 'Authorization';
 
@Component({
  selector: 'ng2file-upload',
  templateUrl: './ng2file-upload.component.html',
  styleUrls: ['./ng2file-upload.component.css']

})
export class Ng2FileUploadComponent implements OnInit {
  
  isUploaded = false;

  canBeClosed = true; 
  //primaryButtonText = 'Valider';
  public showCancelButton = true; 
  //uploading = false;
  //uploadSuccessful = false;
  //showShooseLabel = true;
  //uploadProgress = true;

  constructor(private token: TokenStorage) {
    this.uploader.onSuccessItem = (item:any, response:any, status:any, headers:any) => { 
      ///console.log("onSuccessItem: " + status, response, item); 
      this.isUploaded = true;
      if(response) { 

       } 
      }
  }
  //public uploader:FileUploader = new FileUploader({url: URL, headers: [{ name: 'Autenfication', value: 'Bearer ' + this.token.getToken() }] });
  public uploader:FileUploader = new FileUploader({url: URL, isHTML5: true,method: 'POST',
  itemAlias: 'file', authTokenHeader: 'Authorization', authToken: 'Bearer '+ this.token.getToken() });

  public hasBaseDropZoneOver:boolean = false;
  public hasAnotherDropZoneOver:boolean = false;
 
  
  ngOnInit(){
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
   });
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }
 
  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }
}


// WEBPACK FOOTER //
// ./src/app/admin-app/ng2file/ng2file-upload.component.ts